export const SET_PROCCESS_LIST = 'SET_PROCCESS_LIST';
export const SET_PROCESS_TABLE = 'SET_PROCESS_TABLE';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
export const SET_LOADING = 'SET_LOADING';
export const SET_PROCESS = 'SET_PROCESS';
export const SET_ORIGINAL_STATE_PROCESS = 'SET_ORIGINAL_STATE_PROCESS';
export const SET_GROUP_SELECTED = 'SET_GROUP_SELECTED';
export const SET_STRUCTURES_SELECTED = 'SET_STRUCTURES_SELECTED';
